export default __webpack_public_path__ + "static/01_嘉宾头像_刘奇-01481578703d9799760f3fdf25b32118.png";